import { useState } from "react";
import { Mail, CheckCircle2 } from "lucide-react";

// Shared "email me these numbers" capture bar — posts { email, ...payload } to the given endpoint.
export const EmailScenarioBar = ({ endpoint, payload, testId }) => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | sending | sent | error

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !payload || payload.amount <= 0) return;
    setState("sending");
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}${endpoint}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim(), ...payload }),
      });
      if (!res.ok) throw new Error("send failed");
      setState("sent");
    } catch {
      setState("error");
    }
  };

  return (
    <div className="mt-6 border border-epic-line bg-epic-bg p-5 md:p-6 flex flex-col md:flex-row md:items-center gap-4">
      <p className="font-mono text-xs text-epic-sub leading-relaxed flex-1">
        Want these numbers in writing? We'll email you this exact scenario.
      </p>
      {state === "sent" ? (
        <p
          data-testid={`${testId}-email-success`}
          className="inline-flex items-center gap-2 font-mono text-xs text-green-400"
        >
          <CheckCircle2 className="w-4 h-4" />
          Sent — check your inbox.
        </p>
      ) : (
        <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2 w-full md:w-auto">
          <input
            type="email"
            required
            data-testid={`${testId}-email-input`}
            placeholder="you@email.com"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setState("idle");
            }}
            className="bg-epic-surface border border-epic-line focus:border-epic-accent outline-none px-4 py-3 font-mono text-sm text-epic-text placeholder:text-epic-sub/50 transition-colors duration-200 sm:w-64"
          />
          <button
            type="submit"
            data-testid={`${testId}-email-submit`}
            disabled={state === "sending"}
            className="inline-flex items-center justify-center gap-2 bg-epic-accent px-6 py-3 text-white font-mono text-[11px] uppercase tracking-[0.15em] transition-[background-color,transform] duration-300 hover:bg-epic-accentHover active:scale-95 disabled:opacity-60"
          >
            <Mail className="w-4 h-4" />
            {state === "sending" ? "Sending…" : "Email me these numbers"}
          </button>
        </form>
      )}
      {state === "error" && (
        <p data-testid={`${testId}-email-error`} className="font-mono text-[11px] text-epic-accent">
          Couldn't send — try again.
        </p>
      )}
    </div>
  );
};
